(function () {
  angular.module('MktzapApp.Controllers')
    .controller('ChannelsWaentController', waent);

  waent.$inject = [ '$rootScope', '$scope', '$window', 'CompanyService', 'WaentService', 'FoundationApi', '$state', 'NotificationService', 'PermissionService', 'WhiteListService'];

  function waent ($rootScope, $scope, $window, CompanyService, WaentService, FoundationApi, $state, NotificationService, PermissionService, WhiteListService) {
    var vm = this;

    CompanyService.findForChannel({
      type: 'waent'
    }, function (data) {
      vm.company = data;
    });
    function reloadChannels () {
      WaentService.all(function (data) {
        vm.channels = data;
        WaentService.getSubChannels(
          {
            channels: vm.channels
          }
        )
          .$promise
          .then(function (data) {
            vm.channels = data;
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $scope.labels.requestError)
          });
        if (vm.channel) {
          for (var i = 0; i < data.length; ++i) {
            if (vm.channel.id == data[i].id) {
              vm.channel = data[i];
            }
          }
        }
      });
    }
    reloadChannels();
    vm.openChannelModal = function (channel) {
      vm.channel_status = null;
      vm.isCreating = !channel;
      vm.channel = channel || {};
      vm.channel_status = null;
      vm.authing = false;
      if (typeof vm.channel.subChannels === 'undefined') {
        vm.channel.subChannels = [];
      }
      FoundationApi.publish('channelModal', 'open');
    };

    var validChannelData = function (channel) {
      if (!channel.uuid || !channel.name || !channel.default_sector_id || !vm.company.sectors.some(function (element, index, array) { return element.id == channel.default_sector_id })) {
        NotificationService.warningHandler(null, $scope.labels.requiredFieldsError);
        return false;
      }
      if (channel.subChannels.length > 0) {
        // verificando se existem canais com o mesmo nome
        var subChannelNames = channel.subChannels.map(function (subchannel) { return subchannel.name });
        var hasSameName = subChannelNames.some(function (subchannel, idx) {
          return subChannelNames.indexOf(subchannel) != idx;
        });
        if (hasSameName) {
          NotificationService.errorHandler(null, $scope.labels.duplicateSubChannelNames);
          return false;
        }
        for (var i = 0; i < channel.subChannels.length; i++) {
          if (!channel.subChannels[i].name.length || channel.subChannels[i].name.default_sector_id == '') {
            NotificationService.errorHandler(null, $scope.labels.requiredFieldsError);
            return false;
          }
        }
      }
      return true;
    }

    vm.checkMainSubchannel = function (subChannel) {
      var subchannelsFiltered = vm.channel.subChannels.filter(subchannel => subchannel.main_subchannel === true);
      if (subchannelsFiltered.length > 1) {
        subChannel.main_subchannel = false;
        NotificationService.errorHandler(null, 'Somente um subcanal pode ser utilizado como principal.');
      }
    }

    vm.checkFinishAttendance = function (subChannel) {
      var subchannelsFiltered = vm.channel.subChannels.filter(subchannel => subchannel.finish_attendance === true);
      if (subchannelsFiltered.length > 1) {
        subChannel.finish_attendance = false;
        NotificationService.errorHandler(null, 'Somente um subcanal pode ser indicado para finalização.');
      }
    }

    vm.saveChannel = function (channel) {
      if (!validChannelData(channel)) {
        return;
      }
      vm.channel = channel;
      if (typeof vm.channel.uuid === 'undefined' || !vm.channel.uuid) {
        vm.channel.subChannels = [];
      }
      if (vm.channel.id == undefined) {
        WaentService.create(vm.channel,
          function (data) {
            vm.channel = data;
            reloadChannels();
            NotificationService.successHandler(data, $scope.labels.savedWithSuccess);
          },
          function (error) {
            NotificationService.errorHandler(error, $scope.labels.requestError);
          });
      } else {
        WaentService.update({
          id: vm.channel.id
        }, vm.channel,
        function (data) {
          NotificationService.successHandler(data, $scope.labels.updatedWithSuccess);
        }, function (error) {
          NotificationService.errorHandler(error, $scope.labels.requestError);
        });
      }
      FoundationApi.publish('channelModal', 'close');
    }

    vm.goToTriggers = function (channel) {
      $state.go('main.triggers', { type: 'waent', id: channel.id });
    }

    vm.openPermissionsModal = function () {
      vm.operatorFilter = '';
      vm.allOperatorsSelected = false;
      vm.operatorsSelectedCount = 0;
      vm.selectedUsers = {}
      FoundationApi.publish('activePermissionsModal', 'open');
      PermissionService
        .get({ channelPrefix: 'waent' })
        .$promise
        .then(function (permissions) {
          vm.usersPermissions = permissions;
          permissions.forEach(function (user) {
            vm.selectedUsers[user.id] = user.enabled;
            if (user.enabled) ++vm.operatorsSelectedCount;
          });
          if (permissions.length === vm.operatorsSelectedCount) vm.allOperatorsSelected = true;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao carregar permissões de usuário.')
        })
    }

    vm.selectAllOperators = function () {
      if (vm.allOperatorsSelected) vm.operatorsSelectedCount = vm.usersPermissions.length;
      else vm.operatorsSelectedCount = 0;
      vm.usersPermissions.forEach(function (user) {
        vm.selectedUsers[user.id] = vm.allOperatorsSelected;
      });
    }

    vm.setUserSelected = function (userId) {
      if (!vm.selectedUsers[userId]) {
        vm.allOperatorsSelected = false;
        --vm.operatorsSelectedCount
      } else {
        ++vm.operatorsSelectedCount;
      }
      if (vm.usersPermissions.length === vm.operatorsSelectedCount) vm.allOperatorsSelected = true;
    }

    vm.savePermissionsModal = function () {
      vm.usersPermissions.forEach(function (user) {
        user.enabled = vm.selectedUsers[user.id];
      })
      PermissionService
        .set({
          userData: vm.usersPermissions,
          channelPrefix: 'waent'
        })
        .$promise
        .then(function () {
          NotificationService.successHandler(null, 'Permissões atribuídas com sucesso.');
          FoundationApi.publish('activePermissionsModal', 'close');
          delete vm.usersPermissions;
          delete vm.selectedUsers;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao atribuir permissões de usuário.')
        });
    }

    vm.addSubChannel = function () {
      vm.channel.subChannels.push({ id: '', name: '', accountId: '', commandProcessor: '', main_subchannel: false, overflow: false });
    }

    vm.removeSubChannel = function (index) {
      vm.channel.subChannels.splice(index, 1);
    }

    vm.checkIfSubChannelIsUsed = function (subChannelId, index) {
      if (!subChannelId) {
        vm.removeSubChannel(index);
        return false;
      }
      WhiteListService
        .getByChannelId({ channel_id: vm.channel.id, channelable_type: 'waent' })
        .$promise
        .then(function (data) {
          if (!data.length) {
            vm.removeSubChannel(index);
          }
          for (var i = 0; i < data.length; i++) {
            for (var k = 0; k < data[i].contacts.length; k++) {
              if (typeof data[i].contacts[k].subAccountId !== 'undefined' && data[i].contacts[k].subAccountId == subChannelId) {
                NotificationService.errorHandler(null, 'Subcanal em uso, não será possível remover.')
                continue;
              }
              vm.removeSubChannel(index);
            }
          }
        })
        .catch(function (err) {

        });
    }
  }
})();
